<template>
  <ul class="specs-list-component list-group list-group-flush">
    <li
      v-for="({ title, tooltipText, subSpecs }, index) in specs"
      :key="index"
      class="list-group-item"
      :class="index"
    >
      <Spec :title="title" :tooltip-text="tooltipText" :sub-specs="subSpecs" />
    </li>
  </ul>
</template>

<script>
import Spec from '@/components/Prismic/Landings/Slices/AllPrices/Spec.vue';
export default {
  components: {
    Spec
  },
  props: {
    specs: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.specs-list-component {
  gap: 4em;
  .list-group-item {
    background-color: inherit;
    border: inherit;
    padding: 0;
  }
}
</style>
